import React from 'react';
import styled from '@emotion/styled';

import { css } from '@emotion/react';
import {
    fontSizes,
    gutterSizes,
    mediaQuery,
    breakpoints,
} from '@gumtree/ui-library/src/base/theme';

import Message from '../message/message';
import { newLayout } from '../../../app.style';

const SellerContactMobileBlock: React.FC = () => {
    return (
        <MobileBlock>
            <Title>Send seller a message</Title>
            <Message />
        </MobileBlock>
    );
};

const MobileBlock = styled.section`
    ${css`
        ${newLayout}
    `}
`;

const Title = styled.h2`
    padding-bottom: ${gutterSizes.base};
    margin: 0;

    ${mediaQuery.until(breakpoints.medium)} {
        font-size: ${fontSizes.header};
    }
`;

export default SellerContactMobileBlock;
